import {CircularProgress, FormControl, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import {isArray} from 'lodash';
import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {useFilterPredefined} from './useFilterPredefined';
import {FilterNameType} from '../../../shared/types/filtersSet.types';
import {IReportFilterValue} from './ReportFilter';

interface Props {
  filterByWatch: FilterNameType | string;
}

export const PredefinedField: FC<Props> = ({filterByWatch}) => {
  const {setValue, getValues} = useFormContext<Pick<IReportFilterValue, 'value'>>();

  const value = getValues('value');

  const predefined = useFilterPredefined();

  const predefinedValue = predefined[filterByWatch];

  const onChange = (e: SelectChangeEvent<string | Record<string, any>>) => {
    setValue('value', e.target.value);
  };

  return (
    <FormControl fullWidth>
      <Select
        id="predefined-filter-value"
        value={value}
        onChange={onChange}
        size="small"
        disabled={predefinedValue instanceof Promise || predefinedValue instanceof Error}
      >
        {isArray(predefinedValue) ? (
          (predefinedValue as string[][]).map((item) => (
            <MenuItem key={item[0] + item[1]} value={item[1]}>
              {item[0]}
            </MenuItem>
          ))
        ) : (
          <MenuItem key="another">
            {predefinedValue instanceof Promise ? <CircularProgress size="small" /> : 'Ошибка'}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};
